import { render, staticRenderFns } from "./todayOrder.vue?vue&type=template&id=6afb1156"
import script from "./todayOrder.vue?vue&type=script&lang=js"
export * from "./todayOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports